import { useLazyQuery } from 'src/graphql';
import { ReportReviewQuery } from 'src/graphql/reportReview/query';

export default ({ jobId }) =>
  useLazyQuery(ReportReviewQuery, { variables: { jobId } });
